import { render, staticRenderFns } from "./renter_item_info_personal.vue?vue&type=template&id=67e3824a"
import script from "./renter_item_info_personal.vue?vue&type=script&lang=js"
export * from "./renter_item_info_personal.vue?vue&type=script&lang=js"
import style0 from "./renter_item_info_personal.vue?vue&type=style&index=0&id=67e3824a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports